const state = {
    creditCard: {
        account: null,
        expirationMonth: null,
        expirationYear: null,
        cvv: null,
    }
}

const actions = {
    initCreditCardPayment: (context) => {
        context.commit('SET_CREDIT_CARD', {
            account: null,
            expirationMonth: null,
            expirationYear: null,
            cvv: null,
        });
    }
}

const mutations = {
    SET_CREDIT_CARD: (state, value) => {
        state.creditCard = value;
    }
}

const getters = {
    creditCard: (state) => state.creditCard
}

export default {
    strict: true,
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
